import { render, staticRenderFns } from "./OrderProductDetails.vue?vue&type=template&id=6ed06075&"
import script from "./OrderProductDetails.vue?vue&type=script&lang=js&"
export * from "./OrderProductDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports